import Netx from '@netx/core/bootstrap';
import {getStylePropertyDemo} from '@netx/core-components/Theme';

export const getDefaults = (type = 'light') => {
	const getStyleProperty =
		Netx.getStyleProperty ||
		function (key) {
			return getStylePropertyDemo(key, type);
		};

	return {
		// Our colors
		cellDefaultColor: getStyleProperty('background'),
		cellReadOnlyColor: getStyleProperty('custom-background-light'),
		cellChangedColor: 'rgba(243, 208, 124, 0.28)',
		cellMandatoryColor: 'rgba(247, 197, 197, 0.28)',

		/////////////////////////////////
		// CELLS
		/////////////////////////////////
		// Default cell background color
		backgroundColor: getStyleProperty('background'),
		color: getStyleProperty('text-primary-on-background'),
		// Default cell font
		font: '12px Tahoma, Geneva, sans-serif',
		// Cell font color when selected
		foregroundSelectionColor: getStyleProperty('background'),
		// Cell font when selected
		foregroundSelectionFont: 'normal 12px Tahoma, Geneva, sans-serif',
		// Loose selection background
		selectionRegionOverlayColor: 'rgba(96, 136, 255, 0.2)',
		// Loose selection border
		selectionRegionOutlineColor: '#6088ff',
		// When hovering
		hoverCellHighlight: {
			enabled: true,
			backgroundColor: getStyleProperty('custom-background-light'),
		},
		filterable: false,
		gridBorderRight: true,
		renderFalsy: true,
		// Select multiple cells individually
		multipleSelections: true,
		/////////////////////////////////
		// !CELLS
		/////////////////////////////////

		/////////////////////////////////
		// COLUMNS
		/////////////////////////////////
		// Expand columns to fit content
		columnAutosizing: false,
		// Frozen columns
		fixedColumnCount: 0,
		// When hovering
		hoverColumnHighlight: {
			enabled: true,
			backgroundColor: getStyleProperty('custom-background-light'),
		},
		columnHeaderBackgroundColor: getStyleProperty('custom-background-light'),
		columnHeaderColor: getStyleProperty('text-secondary-on-background'),
		// Column background color when a selection is within column
		columnHeaderBackgroundSelectionColor: getStyleProperty('secondary'),
		// Column font color when selected
		columnHeaderForegroundSelectionColor: getStyleProperty('on-secondary'),
		// Column font when a selection is within column
		columnHeaderForegroundSelectionFont:
			'normal 12px Tahoma, Geneva, sans-serif',
		// Column background when column selected
		columnHeaderBackgroundColumnSelectionColor: '#6088ff',
		// Column font color when selected
		columnHeaderForegroundColumnSelectionColor: '#ffffff',

		minimumColumnWidth: 40,
		/////////////////////////////////
		// !COLUMNS
		/////////////////////////////////

		/////////////////////////////////
		// ROWS
		/////////////////////////////////
		// Allow rows to be resized
		rowResize: true,
		// Allow select entire rows
		rowSelection: true,
		checkboxOnlyRowSelections: false,
		rows: {
			subgrid: {
				0: {
					height: 40,
				},
			},
		},
		// No filters for now
		showFilterRow: false,
		// Allow multiple rows to be selected
		singleRowSelectionMode: false,
		rowHeaderColor: getStyleProperty('text-secondary-on-background'),
		rowHeaderBackgroundColor: getStyleProperty('custom-background-light'),
		// Row background color when a selection is within row
		rowHeaderBackgroundSelectionColor: getStyleProperty('secondary'),
		// Row font color when selected
		rowHeaderForegroundSelectionColor: getStyleProperty('on-secondary'),
		// Row font when a selection is within row
		rowHeaderForegroundSelectionFont: 'normal 12px Tahoma, Geneva, sans-serif',
		// When hovering
		hoverRowHighlight: {
			enabled: true,
			backgroundColor: getStyleProperty('custom-background-light'),
		},
		// Row background when row selected
		rowHeaderBackgroundRowSelectionColor: '#6088ff',
		// Row font color when selected
		rowHeaderForegroundRowSelectionColor: '#ffffff',
		/////////////////////////////////
		// !ROWS
		/////////////////////////////////

		lineColor: getStyleProperty('custom-border'),
	};
};

export default {getDefaults};
